<section class="features">
  <div class="container">
    <div class="features__header">
      <h2 class="features__title">Despliega potentes conversaciones inteligentes</h2>
      <p class="features__subtitle">
        Zapphira.ai se adapta a múltiples casos de uso para satisfacer exactamente lo que tu empresa necesita.
      </p>
    </div>
    
    <div class="features__grid">
      <div class="features__card" *ngFor="let feature of features">
        <div class="features__card-icon">
          <i class="features__icon" [ngClass]="feature.icon"></i> 
        </div>
        <h3 class="features__card-title">{{ feature.title }}</h3>
        <p class="features__card-desc">{{ feature.description }}</p>
      </div>
    </div>
  </div>
</section>